$(function(){
    jQuery('[data-vbg]').youtube_background(

    );
});